import React from "react";
import { motion } from "framer-motion";
import { useLang } from "@/context/LanguageContext";
import { Reveal, Overline } from "@/components/landing/primitives";

const Manifesto = () => {
  const { t } = useLang();
  const m = t.manifesto;

  return (
    <section
      id="manifesto"
      className="relative bg-[#121212] px-5 py-24 md:px-10 md:py-32"
      data-testid="manifesto-section"
    >
      <div className="mx-auto max-w-[1400px]">
        <Reveal>
          <Overline>{m.overline}</Overline>
          <h2 className="mt-5 font-display text-5xl font-black leading-[0.95] text-white md:text-7xl">
            {m.title}
          </h2>
        </Reveal>

        <div className="mt-16 grid gap-12 lg:grid-cols-[0.9fr_1.1fr] lg:gap-20">
          {/* Sticky image */}
          <div className="lg:sticky lg:top-28 lg:h-[70vh]">
            <div className="relative h-full min-h-[360px] overflow-hidden border border-white/10">
              <img
                src="https://images.pexels.com/photos/11455717/pexels-photo-11455717.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
                alt="Precíz motoralkatrészek német minőség"
                className="h-full w-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A]/60 to-transparent" />
              <div className="absolute left-6 top-6 font-mono text-[11px] uppercase tracking-[0.3em] text-brand-green">
                Made with German precision
              </div>
            </div>
          </div>

          {/* Chapters */}
          <div className="flex flex-col">
            {m.chapters.map((ch, i) => (
              <motion.div
                key={ch.num}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
                className="border-t border-white/10 py-10 first:border-t-0 first:pt-0"
                data-testid={`manifesto-chapter-${ch.num}`}
              >
                <div className="flex items-baseline gap-6">
                  <span className="font-mono text-lg text-brand-red">{ch.num}</span>
                  <div>
                    <h3 className="font-display text-3xl font-bold text-white md:text-4xl">
                      {ch.title}
                    </h3>
                    <p className="mt-4 text-base leading-relaxed text-white/60 md:text-lg">
                      {ch.text}
                    </p>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Manifesto;
